import React from "react";
import moment from "moment";

import API from "../../../utilities/api";

import { storage } from '../../../utilities/storage'
import * as Sentry from "@sentry/react";
import { GC } from "../../../utilities/GamecentreSevice";

const logError = (error) => {
  if(error?.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      Sentry.setExtra("response", error.response)
      Sentry.captureException(error)
  } else if(error?.request) {
      // The request was made but no response was received
      Sentry.setExtra("request", error.request)
      Sentry.captureException(error)
  } else {
      // Something happened in setting up the request that triggered an Error
      Sentry.captureException(error?.message)
  }
}

export function levelClearedModal(
  ModalStyle,
  openModal,
  closeModal,
  level,
  title
) {
  let content = (
    <ModalStyle.ModalContent>
      <div className="modal-wrapper relative">
        {/* <div className="modal-header">one</div> */}
        <div className="brocode-btn-new v-semibold">Brocode #{level}</div>
        <div className="success-modal">
          <div className="modal-title v-bold">Tap all the {title} cards.</div>
          <div className="secondary-text v-semibold">
            The system is clearly stating som alert worthy situation here,
            please can you be alerted?
          </div>
          <div
            style={{ marginLeft: "25px" }}
            className="buttons"
            onClick={() => closeModal()}
          >
            <button
              style={{ fontSize: "30px", width: "166px", height: "69px" }}
              className="blob-btn flex justify-center items-center"
            >
              Begin
              <span style={{ paddingLeft: "8px", display: "flex" }}>
                <img
                  src={require("../../../static/img/cta-game-icon.png")}
                  alt="GAME ICON"
                />
              </span>
              <span
                style={{ backgroundColor: "#75c366" }}
                className="blob-btn__inner"
              >
                <span className="blob-btn__blobs">
                  <span className="blob-btn__blob"></span>
                  <span className="blob-btn__blob"></span>
                  <span className="blob-btn__blob"></span>
                  <span className="blob-btn__blob"></span>
                </span>
              </span>
            </button>
            <br />

            <svg
              style={{ height: "0px" }}
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
            >
              <defs>
                <filter id="goo">
                  <feGaussianBlur
                    in="SourceGraphic"
                    result="blur"
                    stdDeviation="10"
                  ></feGaussianBlur>
                  <feColorMatrix
                    in="blur"
                    mode="matrix"
                    values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                    result="goo"
                  ></feColorMatrix>
                  <feBlend in2="goo" in="SourceGraphic" result="mix"></feBlend>
                </filter>
              </defs>
            </svg>
          </div>
          {/* button for proceeding to next level */}
        </div>
      </div>
    </ModalStyle.ModalContent>
  );
  openModal(content);
}

export function formatResult(resultObj, move, timerPerLevel, level = 0, end = false, incomplete = false) {
  let gameId = storage.get.gameId();
  let levelData = [];
  let savedLevelData = storage.get.levelData()
  let checkSaveData = savedLevelData?.levelData?.length ? true : false;

  let newObj = {};

  newObj.totalMoves = checkSaveData ? savedLevelData.totalMoves + move : move;
  newObj.totalWrongMoves = (checkSaveData ? savedLevelData.totalIncorrectMoves : 0) + [
    ...Object.values(resultObj).filter((v) => v.wasCorrect === false),
  ].length;
  newObj.totalCorrectMoves = (checkSaveData ? savedLevelData.totalCorrectMoves : 0) + [
    ...Object.values(resultObj).filter((v) => v.wasCorrect === true),
  ].length;
  newObj.wrongMovePerLevel = {};
  newObj.correctMovePerLevel = {};
  newObj.movePerLevel = {};
  newObj.totalLevelCompleted = end ? incomplete ? Object.keys(timerPerLevel).length - 1 : Object.keys(timerPerLevel).length : Object.keys(timerPerLevel).length - 1;
  newObj.timerPerLevel = timerPerLevel;
  newObj.totalTimeTaken = (checkSaveData ? savedLevelData.totalTimeTaken: 0) + 
    (new Date().getTime() - resultObj["move_1"]?.time?.getTime()) / 1000;

  let moveDub = move;

  while (moveDub !== 0) {
    if (resultObj["move_" + moveDub].wasCorrect === true) {
      if (
        newObj.correctMovePerLevel[
        "level_" + resultObj["move_" + moveDub].level
        ]
      ) {
        newObj.correctMovePerLevel[
          "level_" + resultObj["move_" + moveDub].level
        ] =
          newObj.correctMovePerLevel[
          "level_" + resultObj["move_" + moveDub].level
          ] + 1;
      } else {
        newObj.correctMovePerLevel[
          "level_" + resultObj["move_" + moveDub].level
        ] = 1;
      }
    } else {
      if (
        newObj.wrongMovePerLevel["level_" + resultObj["move_" + moveDub].level]
      ) {
        newObj.wrongMovePerLevel[
          "level_" + resultObj["move_" + moveDub].level
        ] =
          newObj.wrongMovePerLevel[
          "level_" + resultObj["move_" + moveDub].level
          ] + 1;
      } else {
        newObj.wrongMovePerLevel[
          "level_" + resultObj["move_" + moveDub].level
        ] = 1;
      }
    }

    if (newObj.movePerLevel["level_" + resultObj["move_" + moveDub].level]) {
      newObj.movePerLevel["level_" + resultObj["move_" + moveDub].level] =
        newObj.movePerLevel["level_" + resultObj["move_" + moveDub].level] + 1;
    } else {
      newObj.movePerLevel["level_" + resultObj["move_" + moveDub].level] = 1;
    }
    moveDub--;
  }


  /**  Check for Saved Level Data
  */
  function checkSaveDataForLevel(level) { return checkSaveData && level <= savedLevelData?.levelData?.length};
  
  for (let key in timerPerLevel) {
    let firstMove = Object.keys(newObj.movePerLevel).filter(k => parseInt(k.split("_")[1]) < parseInt(key.split("_")[1])).reduce((s, k) => s + newObj.movePerLevel[k], 1)
    let levelStartTime = moment(timerPerLevel[key].start);
    let levelEndTimeStamp = moment(timerPerLevel[key].end);
    let diff = levelEndTimeStamp.diff(levelStartTime, "seconds");
    let level = parseInt(key.split("_")[1]);
    let correctMoves = checkSaveDataForLevel(level) ? savedLevelData?.levelData.find((e) => e.level === level).correctMoves : newObj.correctMovePerLevel[key];
    let incorrectMoves = checkSaveDataForLevel(level) ? savedLevelData?.levelData.find((e) => e.level === level).incorrectMoves : newObj.wrongMovePerLevel[key] ? newObj.wrongMovePerLevel[key] : 0;
    let totalTime = checkSaveDataForLevel(level) ? savedLevelData?.levelData.find((e) => e.level === level).totalTime : diff;
    let totalMoves = checkSaveDataForLevel(level) ? savedLevelData?.levelData.find((e) => e.level === level).totalMoves : newObj.movePerLevel[key];
    let isLevelCleared = checkSaveDataForLevel(level) ? savedLevelData?.levelData.find((e) => e.level === level).isLevelCleared : !incomplete;
    let averageMoveTime = checkSaveDataForLevel(level) ? 
      savedLevelData?.levelData.find((e) => e.level === level).averageMoveTime : 
      (((newObj.correctMovePerLevel[key] + (newObj.wrongMovePerLevel[key] ? newObj.wrongMovePerLevel[key] : 0)) / diff)).toFixed(2);
    let timeForFirstMove = checkSaveDataForLevel(level) ? 
      savedLevelData?.levelData.find((e) => e.level === level).timeForFirstMove :
      `move_${firstMove}` in resultObj ? (resultObj[`move_${firstMove}`].time.getTime() - moment(timerPerLevel[key].start)) / 1000 : 0;

    let resObj = {
      level,
      maxTime: undefined,
      accuracy: undefined,
      numberOfErrorAllowed: undefined,
      // totalTime: diff,
      totalTime,
      totalMoves,
      // totalMoves: newObj.movePerLevel[key],
      // timeForFirstMove: `move_${firstMove}` in resultObj ? (resultObj[`move_${firstMove}`].time.getTime() - moment(timerPerLevel[key].start)) / 1000 : 0,
      timeForFirstMove,
      averageMoveTime,
      // averageMoveTime: (((newObj.correctMovePerLevel[key] + (newObj.wrongMovePerLevel[key] ? newObj.wrongMovePerLevel[key] : 0)) / diff)).toFixed(2),
      // correctMoves: newObj.correctMovePerLevel[key],
      correctMoves,
      incorrectMoves,
      // incorrectMoves: newObj.wrongMovePerLevel[key] ? newObj.wrongMovePerLevel[key] : 0,
      lostLives: undefined,
      isLevelCleared,
      // isLevelCleared: !incomplete,
      levelFailReason:
        timerPerLevel[key].start && timerPerLevel[key].end
          ? undefined
          : resultObj.reason,
      isBonusEarned: undefined,
      timeBeforeStart: undefined,
      // inaccurateMoves: [
      //   {
      //     ruleNumber: key.split("_")[1],
      //     reason: undefined,
      //   },
      // ],
    };
    // console.log("=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=");
    // console.log(resObj);
    // console.log("=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=");
    levelData.push(resObj);
  }

  newObj.accuracy = (newObj.totalCorrectMoves / newObj.totalMoves) * 100;
  newObj.accuracy = Math.floor(newObj.accuracy);
  newObj.totalAverageMoveTime = ((newObj.totalCorrectMoves + (newObj.totalWrongMoves ? newObj.totalWrongMoves : 0)) / newObj.totalTimeTaken).toFixed(2)
  newObj.levelsWithMistakes = levelData.filter((level) => level.incorrectMoves !== 0).length;
  newObj.levelWithFirstMistake = levelData.find((level) => level.incorrectMoves !== 0) ? levelData.find((level) => level.incorrectMoves !== 0).level : 0;
  newObj.averageTimeOnLevelSwitchFirstMove = ((levelData.filter((level) => typeof level.totalMoves !== undefined).reduce((sum, level) => sum + level.timeForFirstMove, 0)) / (levelData.length - 1)).toFixed(2);

  let level1StartTime = moment(timerPerLevel["level_1"].start);
  let firstMoveTime = moment();

  if (level > 0) {
    levelData = levelData.sort((a,b) => a.level - b.level);
    const finalObj = {
      gameData: {
        levelData: end ? [levelData.slice(level - 1, level)[0]] : [levelData.slice(level - 2, level)[0]],
        totalMoves: newObj.totalMoves,
        totalCorrectMoves: newObj.totalCorrectMoves,
        totalIncorrectMoves: newObj.totalWrongMoves,
        totalAccuracy: newObj.accuracy,
        totalLevelCleared: newObj.totalLevelCompleted,
        totalTimeTaken: newObj.totalTimeTaken,
        uniqueLevelsWithMistakes: newObj.levelsWithMistakes,
        firstMistakeOnLevelNumber: newObj.levelWithFirstMistake,
        averageTimeOnLevelSwitchFirstMove: newObj.averageTimeOnLevelSwitchFirstMove,
        // Need to populate
        totalAverageMoveTime: newObj.totalAverageMoveTime,
        // firstMoveTime: ""
      }
    }
    console.log(finalObj)

    const authToken = storage.get.authToken();
    const gameplayId = storage.get.gameplayId();
    console.log("========GET SESSION RESULT========");
    console.log(authToken);
    console.log(gameplayId);
    console.log("==================================");

    if (checkSaveData && savedLevelData.totalIncorrectMoves === 5) {
      console.log("LIVES OVER!")
    } else {
      // API.post(
      //   `/${gameId}/link/${gameplayId}`,
      //   {
      //     ...finalObj,
      //   },
      //   {
      //     headers: {
      //       Authorization: authToken,
      //     },
      //   }
      // )
      //   .then((result) => {
      //     console.log("SUCCESSFULLY UPDATED THE DATA IN THE BACKEND!");
      //   })
      //   .catch((error) => {
      //     console.error(`ERROR::${process.env.REACT_APP_GAME_NAME}::formatResult::${error}`);
      //     logError(error)
      //   });
      GC.sendGameDataSaveMessage(finalObj);
    }
    
  }

  newObj.backendObj = {
    gameData: {
      levelData: levelData,
      totalMoves: newObj.totalMoves,
      totalCorrectMoves: newObj.totalCorrectMoves,
      totalIncorrectMoves: newObj.totalWrongMoves,
      totalAccuracy: newObj.accuracy,
      totalLevelCleared: newObj.totalLevelCompleted,
      totalTimeTaken: newObj.totalTimeTaken,
      // Need to populate
      totalAverageMoveTime: "",
      // firstMoveTime: ""
    }
  };

  // console.log("=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=");
  // console.log(newObj.backendObj);
  // console.log("=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=");

  return newObj;
}